<template>
  <main class="w-full max-w-none">
    <div class="mx-auto w-full max-w-full px-0">
      <div class="mb-8">
        <h1 class="text-2xl md:text-3xl font-bold text-gray-900 mb-2">月度对账单下载</h1>
        <AdvancedFeatureNotice
          api-url="/api/v2/bs/monthstatement/download"
        />
        <p class="text-gray-600">用于下载指定账号和月份范围的对账单。说明： - 支持按起止月份范围批量下载 - 返回ZIP压缩包文件流</p>
      </div>

      <div class="grid grid-cols-1 lg:grid-cols-5 gap-3 w-full">
        <!-- 左侧内容 -->
        <div class="w-full lg:col-span-3">
          <Card class="mb-8">
            <CardHeader>
              <CardTitle>接口说明</CardTitle>
              <CardDescription>
                用于下载指定账号和月份范围的对账单。说明： - 支持按起止月份范围批量下载 - 返回ZIP压缩包文件流
              </CardDescription>
            </CardHeader>
            <CardContent>
              <div
                class="flex items-center gap-4 mb-6 p-4 bg-gray-50 rounded-lg"
              >
                <span
                  class="px-3 py-1 bg-blue-100 text-blue-800 text-sm font-medium rounded-full"
                  >GET</span
                >
                <code class="text-sm font-mono">/api/v2/bs/monthstatement/download</code>
              </div>

              <div class="space-y-6">
                <div>
                  <h3 class="text-lg font-medium text-gray-900 mb-3">
                    请求头参数
                  </h3>
                  <div class="overflow-x-auto">
                    <table class="min-w-max md:min-w-full divide-y divide-gray-200">
                      <thead class="bg-gray-50">
                        <tr>
                          <th
                            class="px-3 md:px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
                          >
                            参数名
                          </th>
                          <th
                            class="px-3 md:px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
                          >
                            类型
                          </th>
                          <th
                            class="px-3 md:px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
                          >
                            必需
                          </th>
                          <th
                            class="px-3 md:px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
                          >
                            描述
                          </th>
                          <th
                            class="px-3 md:px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
                          >
                            示例值
                          </th>
                        </tr>
                      </thead>
                      <tbody class="bg-white divide-y divide-gray-200">
                        <tr>
                          <td
                            class="px-3 md:px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900"
                          >
                            x-app-id
                          </td>
                          <td
                            class="px-3 md:px-6 py-4 whitespace-nowrap text-sm text-gray-500"
                          >
                            String
                          </td>
                          <td
                            class="px-3 md:px-6 py-4 whitespace-nowrap text-sm text-gray-500"
                          >
                            是
                          </td>
                          <td class="px-3 md:px-6 py-4 text-sm text-gray-500">
                            APP ID
                          </td>
                          <td class="px-3 md:px-6 py-4 text-sm text-gray-500 break-all">
                            4d9414e89bc24b0d89b678d9f20bc56a
                          </td>
                        </tr>
                        <tr>
                          <td
                            class="px-3 md:px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900"
                          >
                            x-app-secret
                          </td>
                          <td
                            class="px-3 md:px-6 py-4 whitespace-nowrap text-sm text-gray-500"
                          >
                            String
                          </td>
                          <td
                            class="px-3 md:px-6 py-4 whitespace-nowrap text-sm text-gray-500"
                          >
                            是
                          </td>
                          <td class="px-3 md:px-6 py-4 text-sm text-gray-500">
                            API Key
                          </td>
                          <td class="px-3 md:px-6 py-4 text-sm text-gray-500 break-all">
                            8201e508ef948b8fcdca855729e7ee34
                          </td>
                        </tr>
                        <tr>
                          <td
                            class="px-3 md:px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900"
                          >
                            x-customer-code
                          </td>
                          <td
                            class="px-3 md:px-6 py-4 whitespace-nowrap text-sm text-gray-500"
                          >
                            String
                          </td>
                          <td
                            class="px-3 md:px-6 py-4 whitespace-nowrap text-sm text-gray-500"
                          >
                            是
                          </td>
                          <td class="px-3 md:px-6 py-4 text-sm text-gray-500">
                            客户编号
                          </td>
                          <td class="px-3 md:px-6 py-4 text-sm text-gray-500 break-all">
                            CUSTFA48DD8EFF437956
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>

                <div>
                  <h3 class="text-lg font-medium text-gray-900 mb-3">
                    请求参数
                  </h3>
                  <div class="overflow-x-auto">
                    <table class="min-w-max md:min-w-full divide-y divide-gray-200">
                      <thead class="bg-gray-50">
                        <tr>
                          <th
                            class="px-3 md:px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
                          >
                            参数名
                          </th>
                          <th
                            class="px-3 md:px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
                          >
                            类型
                          </th>
                          <th
                            class="px-3 md:px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
                          >
                            必需
                          </th>
                          <th
                            class="px-3 md:px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
                          >
                            描述
                          </th>
                          <th
                            class="px-3 md:px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
                          >
                            示例值
                          </th>
                        </tr>
                      </thead>
                      <tbody class="bg-white divide-y divide-gray-200">
                        <tr>
                          <td
                            class="px-3 md:px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900"
                          >
                            accountNo
                          </td>
                          <td
                            class="px-3 md:px-6 py-4 whitespace-nowrap text-sm text-gray-500"
                          >
                            String
                          </td>
                          <td
                            class="px-3 md:px-6 py-4 whitespace-nowrap text-sm text-gray-500"
                          >
                            是
                          </td>
                          <td class="px-3 md:px-6 py-4 text-sm text-gray-500 break-all">
                            银行账号
                          </td>
                          <td class="px-3 md:px-6 py-4 text-sm text-gray-500 break-all">
                            6222021234567890
                          </td>
                        </tr>
                        <tr>
                          <td
                            class="px-3 md:px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900"
                          >
                            transactionStartMonthId
                          </td>
                          <td
                            class="px-3 md:px-6 py-4 whitespace-nowrap text-sm text-gray-500"
                          >
                            Integer
                          </td>
                          <td
                            class="px-3 md:px-6 py-4 whitespace-nowrap text-sm text-gray-500"
                          >
                            是
                          </td>
                          <td class="px-3 md:px-6 py-4 text-sm text-gray-500 break-all">
                            起始月份，格式：yyyyMM
                          </td>
                          <td class="px-3 md:px-6 py-4 text-sm text-gray-500 break-all">
                            202401
                          </td>
                        </tr>
                        <tr>
                          <td
                            class="px-3 md:px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900"
                          >
                            transactionEndMonthId
                          </td>
                          <td
                            class="px-3 md:px-6 py-4 whitespace-nowrap text-sm text-gray-500"
                          >
                            Integer
                          </td>
                          <td
                            class="px-3 md:px-6 py-4 whitespace-nowrap text-sm text-gray-500"
                          >
                            是
                          </td>
                          <td class="px-3 md:px-6 py-4 text-sm text-gray-500 break-all">
                            截止月份，格式：yyyyMM
                          </td>
                          <td class="px-3 md:px-6 py-4 text-sm text-gray-500 break-all">
                            202412
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>

                <!-- <div>
                  <h3 class="text-lg font-medium text-gray-900 mb-3">
                    响应参数（成功）
                  </h3>
                  <div class="overflow-x-auto">
                    <table class="min-w-max md:min-w-full divide-y divide-gray-200">
                      <thead class="bg-gray-50">
                        <tr>
                          <th
                            class="px-3 md:px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
                          >
                            参数名
                          </th>
                          <th
                            class="px-3 md:px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
                          >
                            类型
                          </th>
                          <th
                            class="px-3 md:px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
                          >
                            描述
                          </th>
                        </tr>
                      </thead>
                      <tbody class="bg-white divide-y divide-gray-200">
                        <tr>
                          <td
                            class="px-3 md:px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900"
                          >
                            文件流
                          </td>
                          <td
                            class="px-3 md:px-6 py-4 whitespace-nowrap text-sm text-gray-500"
                          >
                            Binary
                          </td>
                          <td class="px-3 md:px-6 py-4 text-sm text-gray-500">
                            返回对账单压缩包文件流，文件名格式：银行月度对账单下载_yyyyMMdd_HHmmss.zip
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>

                <div>
                  <h3 class="text-lg font-medium text-gray-900 mb-3">
                    响应参数（失败）
                  </h3>
                  <div class="overflow-x-auto">
                    <table class="min-w-max md:min-w-full divide-y divide-gray-200">
                      <thead class="bg-gray-50">
                        <tr>
                          <th
                            class="px-3 md:px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
                          >
                            参数名
                          </th>
                          <th
                            class="px-3 md:px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
                          >
                            类型
                          </th>
                          <th
                            class="px-3 md:px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
                          >
                            描述
                          </th>
                        </tr>
                      </thead>
                      <tbody class="bg-white divide-y divide-gray-200">
                        <tr>
                          <td
                            class="px-3 md:px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900"
                          >
                            code
                          </td>
                          <td
                            class="px-3 md:px-6 py-4 whitespace-nowrap text-sm text-gray-500"
                          >
                            String
                          </td>
                          <td class="px-3 md:px-6 py-4 text-sm text-gray-500">
                            错误码，"400" 或 "500"
                          </td>
                        </tr>
                        <tr>
                          <td
                            class="px-3 md:px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900"
                          >
                            message
                          </td>
                          <td
                            class="px-3 md:px-6 py-4 whitespace-nowrap text-sm text-gray-500"
                          >
                            String
                          </td>
                          <td class="px-3 md:px-6 py-4 text-sm text-gray-500">
                            错误描述
                          </td>
                        </tr>
                        <tr>
                          <td
                            class="px-3 md:px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900"
                          >
                            status
                          </td>
                          <td
                            class="px-3 md:px-6 py-4 whitespace-nowrap text-sm text-gray-500"
                          >
                            String
                          </td>
                          <td class="px-3 md:px-6 py-4 text-sm text-gray-500">
                            HTTP 状态码
                          </td>
                        </tr>
                        <tr>
                          <td
                            class="px-3 md:px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900"
                          >
                            successResponse
                          </td>
                          <td
                            class="px-3 md:px-6 py-4 whitespace-nowrap text-sm text-gray-500"
                          >
                            Boolean
                          </td>
                          <td class="px-3 md:px-6 py-4 text-sm text-gray-500">
                            成功标记，失败固定 false
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div> -->
              </div>
            </CardContent>
          </Card>
        </div>

        <!-- 右侧"试一试"区域 -->
        <div class="w-full lg:col-span-2">
          <Card>
            <CardHeader>
              <CardTitle>试一试</CardTitle>
              <CardDescription>填写参数并下载月度对账单压缩包</CardDescription>
            </CardHeader>
            <CardContent>
              <div class="border-b border-gray-200">
                <nav class="-mb-px flex space-x-8 overflow-x-auto">
                  <button
                    v-for="language in languages"
                    :key="language.id"
                    @click="activeLanguage = language.id"
                    class="whitespace-nowrap py-2 px-1 border-b-2 font-medium text-sm"
                    :class="[
                      activeLanguage === language.id
                        ? 'border-[var(--primary)] text-[var(--primary)]'
                        : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300',
                    ]"
                  >
                    {{ language.name }}
                  </button>
                </nav>
              </div>

              <div class="mt-6">
                <pre
                  class="bg-gray-800 text-gray-100 p-4 rounded-md text-sm overflow-x-auto"
                ><code>{{ getRequestText() }}</code></pre>
                <div class="space-y-4 mt-4">
                  <div>
                    <label class="block text-sm font-medium text-gray-700 mb-1"
                      >x-app-id <span class="text-red-500">*</span></label
                    >
                    <input
                      v-model="appId"
                      type="text"
                      :class="{ '!border-red-500': showValidation && !appId }"
                      class="w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-[var(--primary)] focus:border-[var(--primary)]"
                    />
                  </div>
                  <div>
                    <label class="block text-sm font-medium text-gray-700 mb-1"
                      >x-app-secret <span class="text-red-500">*</span></label
                    >
                    <input
                      v-model="authorization"
                      type="text"
                      :class="{ '!border-red-500': showValidation && !authorization }"
                      class="w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-[var(--primary)] focus:border-[var(--primary)]"
                    />
                  </div>
                  <div>
                    <label class="block text-sm font-medium text-gray-700 mb-1"
                      >x-customer-code <span class="text-red-500">*</span></label
                    >
                    <input
                      v-model="customerCode"
                      type="text"
                      :class="{ '!border-red-500': showValidation && !customerCode }"
                      class="w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-[var(--primary)] focus:border-[var(--primary)]"
                    />
                  </div>

                  <div class="grid grid-cols-1 gap-4">
                    <div>
                      <label
                        class="block text-sm font-medium text-gray-700 mb-1"
                        >accountNo <span class="text-red-500">*</span></label
                      >
                      <input
                        v-model="accountNo"
                        type="text"
                        placeholder="6222021234567890"
                        :class="{ '!border-red-500': showValidation && !accountNo }"
                        class="w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-[var(--primary)] focus:border-[var(--primary)]"
                      />
                    </div>
                    <div>
                      <label
                        class="block text-sm font-medium text-gray-700 mb-1"
                        >transactionStartMonthId (yyyyMM) <span class="text-red-500">*</span></label
                      >
                      <input
                        v-model="transactionStartMonthId"
                        type="text"
                        placeholder="202401"
                        :class="{ '!border-red-500': showValidation && !transactionStartMonthId }"
                        class="w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-[var(--primary)] focus:border-[var(--primary)]"
                      />
                    </div>
                    <div>
                      <label
                        class="block text-sm font-medium text-gray-700 mb-1"
                        >transactionEndMonthId (yyyyMM) <span class="text-red-500">*</span></label
                      >
                      <input
                        v-model="transactionEndMonthId"
                        type="text"
                        placeholder="202412"
                        :class="{ '!border-red-500': showValidation && !transactionEndMonthId }"
                        class="w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-[var(--primary)] focus:border-[var(--primary)]"
                      />
                    </div>
                  </div>

                  <button
                    @click="downloadStatement"
                    :disabled="loading"
                    class="w-full bg-[var(--primary)] hover:bg-[color:var(--primary)] text-white font-medium py-2 px-4 rounded-md transition duration-200 ease-in-out transform hover:scale-105 focus:outline-none focus:ring-2 focus:ring-[var(--primary)] focus:ring-offset-2 disabled:opacity-50 disabled:cursor-not-allowed"
                  >
                    {{ loading ? "下载中..." : "下载对账单" }}
                  </button>
                </div>
              </div>

              <div v-if="response && !downloadTriggered" class="mt-6">
                <h3 class="text-lg font-medium text-gray-900 mb-2">响应结果</h3>
                <pre
                  class="bg-gray-800 text-gray-100 p-4 rounded-md text-sm overflow-x-auto"
                ><code class="language-json">{{ response }}</code></pre>
              </div>

              <div v-if="downloadTriggered && !response" class="mt-6">
                <h3 class="text-lg font-medium text-gray-900 mb-2">下载状态</h3>
                <div class="p-4 bg-green-50 rounded-md">
                  <p class="text-sm text-green-700">
                    文件已开始下载，请查看浏览器下载记录。
                  </p>
                </div>
              </div>
            </CardContent>
          </Card>
        </div>
      </div>
    </div>
  </main>
</template>

<script setup lang="ts">
import { ref, onMounted, watch, nextTick } from "vue";
import Card from "./ui/Card.vue";
import CardHeader from "./ui/CardHeader.vue";
import CardTitle from "./ui/CardTitle.vue";
import CardDescription from "./ui/CardDescription.vue";
import CardContent from "./ui/CardContent.vue";
import AdvancedFeatureNotice from "./ui/AdvancedFeatureNotice.vue";
import { useCodeHighlight } from "@/composables/useCodeHighlight";
import httpService from "@/lib/http";
import hljs from "highlight.js/lib/core";

// 使用代码高亮
const highlightCode = () => {
  nextTick(() => {
    setTimeout(() => {
      const allCodeBlocks = document.querySelectorAll("pre code");

      const languageMap: { [key: string]: string } = {
        curl: "language-bash",
        javascript: "language-javascript",
        python: "language-python",
        java: "language-java",
        csharp: "language-csharp",
        php: "language-php",
        ruby: "language-ruby",
      };

      const langClass = languageMap[activeLanguage.value];

      allCodeBlocks.forEach((block) => {
        const el = block as HTMLElement;
        const isJson = el.classList.contains("language-json");

        el.className = "";
        el.removeAttribute("data-highlighted");

        el.classList.add("hljs");

        if (isJson) {
          el.classList.add("language-json");
        } else if (langClass) {
          el.classList.add(langClass);
        }

        try {
          hljs.highlightElement(el);
        } catch (error) {
          console.warn("代码高亮失败:", error);
        }
      });
    }, 100);
  });
};

// 初始化代码高亮
useCodeHighlight("pre code");
onMounted(() => {
  highlightCode();
});

const DEFAULT_APP_ID = "登录后自动获取";
const DEFAULT_APP_SECRET = "登录后自动获取";
const DEFAULT_CUSTOMER_CODE = "登录后自动获取";

const appId = ref(DEFAULT_APP_ID);
const authorization = ref(DEFAULT_APP_SECRET);
const customerCode = ref(DEFAULT_CUSTOMER_CODE);
const accountNo = ref("");
const transactionStartMonthId = ref("");
const transactionEndMonthId = ref("");

const loading = ref(false);
const showValidation = ref(false);
const activeLanguage = ref("curl");
const response = ref("");
const downloadTriggered = ref(false);

// 获取应用信息
const getApplicationInfo = async () => {
  try {
    const res = await httpService.get<any>("/nxb/console/application/get");

    if (res) {
      return {
        appId: res.appId,
        appSecret: res.appSecret,
      };
    }
    return null;
  } catch (error) {
    console.log("获取应用信息失败:", error);
    return null;
  }
};

// 获取客户信息
const getCustomerInfo = async () => {
  try {
    const res = await httpService.get<any>("/nxb/console/customer/listWithSummary", {
      pageNow: 1,
      pageSize: 10,
    });

    if (res) {
      return res.customers[0].customerCode;
    }
    return null;
  } catch (error) {
    console.log("获取客户信息失败:", error);
    return null;
  }
};

// 登录后自动获取用户信息
const autoFetchUserInfo = async () => {
  const userInfoStr = localStorage.getItem("userInfo");

  if (userInfoStr) {
    const appInfo = await getApplicationInfo();

    if (appInfo) {
      appId.value = appInfo.appId;
      authorization.value = appInfo.appSecret;
    }

    const customerCodeValue = await getCustomerInfo();
    if (customerCodeValue) {
      customerCode.value = customerCodeValue;
    }
  }
};

// 组件挂载时自动获取用户信息
onMounted(() => {
  autoFetchUserInfo();
});

// 监听响应式变量变化，重新应用代码高亮
watch(
  [
    appId,
    authorization,
    customerCode,
    accountNo,
    transactionStartMonthId,
    transactionEndMonthId,
    activeLanguage,
    response,
  ],
  () => {
    highlightCode();
  },
  { flush: "post" }
);

// 语言选项
const languages = [
  { id: "curl", name: "cURL" },
  { id: "javascript", name: "JavaScript" },
  { id: "python", name: "Python" },
  { id: "java", name: "Java" },
  { id: "csharp", name: "C#" },
  { id: "php", name: "PHP" },
  { id: "ruby", name: "Ruby" },
];

// 验证月份格式
const validateMonthFormat = (month: string): boolean => {
  if (!month) return false;
  const regex = /^\d{6}$/;
  if (!regex.test(month)) return false;

  const year = parseInt(month.substring(0, 4));
  const monthNum = parseInt(month.substring(4, 6));

  if (year < 1900 || year > 2100) return false;
  if (monthNum < 1 || monthNum > 12) return false;

  return true;
};

// 获取请求文本（用于代码示例展示）
const getRequestText = () => {
  const baseUrl = import.meta.env.VITE_API_URL + "/api/v2/bs/monthstatement/download";
  const params = new URLSearchParams();
  if (accountNo.value) params.append("accountNo", accountNo.value);
  if (transactionStartMonthId.value) params.append("transactionStartMonthId", transactionStartMonthId.value);
  if (transactionEndMonthId.value) params.append("transactionEndMonthId", transactionEndMonthId.value);

  const qs = params.toString() || "accountNo=6222021234567890&transactionStartMonthId=202401&transactionEndMonthId=202412";

  switch (activeLanguage.value) {
    case "curl":
      return (
        `curl -X GET '${baseUrl}?${qs}' \\\n` +
        `  -H 'x-app-id: ${appId.value}' \\\n` +
        `  -H 'x-app-secret: ${authorization.value}' \\\n` +
        `  -H 'x-customer-code: ${customerCode.value}' \\\n` +
        `  --output monthly_statements.zip`
      );

    case "javascript":
      return (
        `// 方式一：使用隐藏 <a> 标签下载\n` +
        `const a = document.createElement('a');\n` +
        `a.href = '${baseUrl}?${qs}';\n` +
        `a.click();\n\n` +
        `// 方式二：使用 window.open\n` +
        `// window.open('${baseUrl}?${qs}');\n\n` +
        `// 方式三：使用 fetch 判断返回类型\n` +
        `fetch('${baseUrl}?${qs}', {\n` +
        `  headers: {\n` +
        `    'x-app-id': '${appId.value}',\n` +
        `    'x-app-secret': '${authorization.value}',\n` +
        `    'x-customer-code': '${customerCode.value}'\n` +
        `  }\n` +
        `})\n` +
        `.then(response => {\n` +
        `  const contentType = response.headers.get('content-type');\n` +
        `  if (contentType === 'application/x-download') {\n` +
        `    return response.blob();\n` +
        `  }\n` +
        `  return response.json().then(err => { throw err; });\n` +
        `})\n` +
        `.then(blob => {\n` +
        `  const url = URL.createObjectURL(blob);\n` +
        `  const a = document.createElement('a');\n` +
        `  a.href = url;\n` +
        `  a.download = 'monthly_statements.zip';\n` +
        `  a.click();\n` +
        `  URL.revokeObjectURL(url);\n` +
        `})\n` +
        `.catch(err => console.error('下载失败:', err));`
      );

    case "python":
      return (
        `import requests\n\n` +
        `url = "${baseUrl}"\n` +
        `params = {\n` +
        (accountNo.value ? `    'accountNo': '${accountNo.value}',\n` : "") +
        (transactionStartMonthId.value ? `    'transactionStartMonthId': ${transactionStartMonthId.value},\n` : "") +
        (transactionEndMonthId.value ? `    'transactionEndMonthId': ${transactionEndMonthId.value}\n` : "") +
        `}\n` +
        `headers = {\n` +
        `    'x-app-id': '${appId.value}',\n` +
        `    'x-app-secret': '${authorization.value}',\n` +
        `    'x-customer-code': '${customerCode.value}'\n` +
        `}\n\n` +
        `response = requests.get(url, headers=headers, params=params)\n\n` +
        `if response.headers.get('content-type') == 'application/x-download':\n` +
        `    with open('monthly_statements.zip', 'wb') as f:\n` +
        `        f.write(response.content)\n` +
        `    print("下载成功！")\n` +
        `else:\n` +
        `    print("下载失败:", response.json())\n`
      );

    case "java":
      return (
        `OkHttpClient client = new OkHttpClient();\n\n` +
        `HttpUrl.Builder urlBuilder = HttpUrl.parse("${baseUrl}").newBuilder();\n` +
        (accountNo.value ? `urlBuilder.addQueryParameter("accountNo", "${accountNo.value}");\n` : "") +
        (transactionStartMonthId.value ? `urlBuilder.addQueryParameter("transactionStartMonthId", "${transactionStartMonthId.value}");\n` : "") +
        (transactionEndMonthId.value ? `urlBuilder.addQueryParameter("transactionEndMonthId", "${transactionEndMonthId.value}");\n` : "") +
        `\n` +
        `Request request = new Request.Builder()\n` +
        `    .url(urlBuilder.build())\n` +
        `    .get()\n` +
        `    .addHeader("x-app-id", "${appId.value}")\n` +
        `    .addHeader("x-app-secret", "${authorization.value}")\n` +
        `    .addHeader("x-customer-code", "${customerCode.value}")\n` +
        `    .build();\n\n` +
        `try (Response response = client.newCall(request).execute()) {\n` +
        `    if ("application/x-download".equals(response.header("Content-Type"))) {\n` +
        `        byte[] bytes = response.body().bytes();\n` +
        `        Files.write(Paths.get("monthly_statements.zip"), bytes);\n` +
        `        System.out.println("下载成功！");\n` +
        `    } else {\n` +
        `        System.out.println("下载失败: " + response.body().string());\n` +
        `    }\n` +
        `}`
      );

    case "csharp":
      return (
        `using var client = new HttpClient();\n` +
        `client.DefaultRequestHeaders.Add("x-app-id", "${appId.value}");\n` +
        `client.DefaultRequestHeaders.Add("x-app-secret", "${authorization.value}");\n` +
        `client.DefaultRequestHeaders.Add("x-customer-code", "${customerCode.value}");\n\n` +
        `string url = "${baseUrl}?${qs}";\n` +
        `var response = await client.GetAsync(url);\n\n` +
        `if (response.Headers.Contains("Content-Type") && \n` +
        `    response.Headers.GetValues("Content-Type").First() == "application/x-download")\n` +
        `{\n` +
        `    var bytes = await response.Content.ReadAsByteArrayAsync();\n` +
        `    await File.WriteAllBytesAsync("monthly_statements.zip", bytes);\n` +
        `    Console.WriteLine("下载成功！");\n` +
        `}\n` +
        `else\n` +
        `{\n` +
        `    var error = await response.Content.ReadAsStringAsync();\n` +
        `    Console.WriteLine($"下载失败: {error}");\n` +
        `}`
      );

    case "php":
      return (
        `<?php\n\n` +
        `$curl = curl_init();\n\n` +
        `curl_setopt_array($curl, [\n` +
        `    CURLOPT_URL => '${baseUrl}?${qs}',\n` +
        `    CURLOPT_RETURNTRANSFER => true,\n` +
        `    CURLOPT_CUSTOMREQUEST => 'GET',\n` +
        `    CURLOPT_HTTPHEADER => [\n` +
        `        'x-app-id: ${appId.value}',\n` +
        `        'x-app-secret: ${authorization.value}',\n` +
        `        'x-customer-code: ${customerCode.value}'\n` +
        `    ],\n` +
        `]);\n\n` +
        `$response = curl_exec($curl);\n` +
        `$contentType = curl_getinfo($curl, CURLINFO_CONTENT_TYPE);\n` +
        `curl_close($curl);\n\n` +
        `if ($contentType === 'application/x-download') {\n` +
        `    file_put_contents('monthly_statements.zip', $response);\n` +
        `    echo "下载成功！\\n";\n` +
        `} else {\n` +
        `    echo "下载失败: " . $response . "\\n";\n` +
        `}`
      );

    case "ruby":
      return (
        `require "uri"\n` +
        `require "net/http"\n\n` +
        `uri = URI("${baseUrl}?${qs}")\n` +
        `http = Net::HTTP.new(uri.host, uri.port)\n` +
        `http.use_ssl = (uri.scheme == "https")\n\n` +
        `request = Net::HTTP::Get.new(uri)\n` +
        `request["x-app-id"] = "${appId.value}"\n` +
        `request["x-app-secret"] = "${authorization.value}"\n` +
        `request["x-customer-code"] = "${customerCode.value}"\n\n` +
        `response = http.request(request)\n\n` +
        `if response["content-type"] == "application/x-download"\n` +
        `    File.open("monthly_statements.zip", "wb") do |file|\n` +
        `        file.write(response.body)\n` +
        `    end\n` +
        `    puts "下载成功！"\n` +
        `else\n` +
        `    puts "下载失败: \#{response.body}"\n` +
        `end`
      );

    default:
      return "";
  }
};

// 下载月度对账单
const downloadStatement = async () => {
  showValidation.value = true;
  response.value = "";
  downloadTriggered.value = false;

  // 验证必填参数
  if (!appId.value || !authorization.value || !customerCode.value) {
    alert("请填写所有必填的 Header 参数");
    return;
  }

  if (!accountNo.value) {
    alert("请填写银行账号");
    return;
  }

  if (!transactionStartMonthId.value) {
    alert("请填写起始月份");
    return;
  }

  if (!transactionEndMonthId.value) {
    alert("请填写截止月份");
    return;
  }

  // 验证月份格式
  if (!validateMonthFormat(transactionStartMonthId.value)) {
    response.value = JSON.stringify(
      {
        code: "400",
        message: "起始月份格式不正确，应为 yyyyMM 格式（如：202401）",
        status: "400",
        successResponse: false,
      },
      null,
      2
    );
    highlightCode();
    return;
  }

  if (!validateMonthFormat(transactionEndMonthId.value)) {
    response.value = JSON.stringify(
      {
        code: "400",
        message: "截止月份格式不正确，应为 yyyyMM 格式（如：202412）",
        status: "400",
        successResponse: false,
      },
      null,
      2
    );
    highlightCode();
    return;
  }

  // 验证起始日期不能大于截止日期
  if (parseInt(transactionStartMonthId.value) > parseInt(transactionEndMonthId.value)) {
    response.value = JSON.stringify(
      {
        code: "400",
        message: "起始月份不能大于截止月份",
        status: "400",
        successResponse: false,
      },
      null,
      2
    );
    highlightCode();
    return;
  }

  loading.value = true;

  try {
    const params: Record<string, string> = {
      accountNo: accountNo.value,
      transactionStartMonthId: transactionStartMonthId.value,
      transactionEndMonthId: transactionEndMonthId.value,
    };

    const res = await httpService.get<any>("/api/v2/bs/monthstatement/download", params, {
      headers: {
        "x-app-id": appId.value,
        "x-app-secret": authorization.value,
        "x-customer-code": customerCode.value,
      },
      responseType: "blob",
    });

    const raw = res && (res as any).data ? (res as any).data : res;

    // 检查是否为 JSON（错误响应）
    if (raw instanceof Blob && raw.type === "application/json") {
      const text = await raw.text();
      try {
        const json = JSON.parse(text);
        response.value = JSON.stringify(json, null, 2);
        nextTick(() => {
          highlightCode();
        });
        return;
      } catch (e) {
        console.error("解析 JSON 失败", e);
      }
    }

    // 成功：触发下载
    const blob = raw instanceof Blob ? raw : new Blob([raw], { type: "application/zip" });
    const url = URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;

    // 从 Content-Disposition 获取文件名，或使用默认名称
    let filename = `monthly_statements_${transactionStartMonthId.value}_${transactionEndMonthId.value}.zip`;
    if ((res as any).headers) {
      const contentDisposition = (res as any).headers["content-disposition"];
      if (contentDisposition) {
        const match = contentDisposition.match(/filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/);
        if (match && match[1]) {
          filename = match[1].replace(/['"]/g, "");
        }
      }
    }

    a.download = filename;
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    URL.revokeObjectURL(url);

    downloadTriggered.value = true;
    showValidation.value = false;
  } catch (error) {
    console.error("下载失败:", error);
    if (error && typeof error === "object") {
      response.value = JSON.stringify(error, null, 2);
    } else {
      response.value = String(error);
    }
  } finally {
    loading.value = false;
  }
};
</script>
